module.exports = __webpack_public_path__ + "media/images/gastro_gewerbe_660-1b152e9ca7726b19cd066f5bbc4f9974.jpg";